import { margin, padding } from "ds_legacy/materials/metrics";
import {
  ActivableToggle,
  DatePickerWithLabel,
  GAP,
  SMALL_INPUT_WIDTH,
  TEXT_AREA_MAX_CHARACTERS,
  TextAreaWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const PatientConfirmation = () => {
  const translations = useTranslations();
  return (
    <ActivableToggle
      componentIfFalse={
        <TextAreaWithLabel
          characterLimit={TEXT_AREA_MAX_CHARACTERS}
          elementName="transitional_care_patient_confirmation_explanation"
          label={
            translations.patientForms.transitionalCareForm.sectionB
              .textFieldExplanationLabel
          }
          marginOverride={margin(0)}
          multiline
          required
        />
      }
      componentIfTrue={
        <DatePickerWithLabel
          elementName="transitional_care_patient_confirmation_date"
          inputSx={{ width: SMALL_INPUT_WIDTH }}
          isBold
          label={
            translations.patientForms.transitionalCareForm.sectionB
              .dateFieldLabel
          }
          shouldDisableFuture
          wrapperSx={{ width: "100%" }}
        />
      }
      elementName="transitional_care_patient_confirmation"
      label={
        translations.patientForms.transitionalCareForm.sectionB
          .toggleConfirmedWithPatient
      }
      sideMutation={(value, mutate) => {
        if (!value) {
          return mutate(null, "transitional_care_patient_confirmation_date");
        }

        return mutate(
          null,
          "transitional_care_patient_confirmation_explanation",
        );
      }}
      wrapperStyle={{ padding: padding(GAP, 0, 0) }}
    />
  );
};
